import { Box } from "@mui/material";
import { Table as TableAntd, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as Empty } from "../../assets/icon/Empty.svg";
import "./common.scss";
const Table: React.FC<TableProps<any>> = ({ ...props }) => {
  return <TableAntd {...props} locale={{ emptyText: <EmptyRerod /> }} />;
};

export default Table;

const EmptyRerod = () => {
  const { i18n, t } = useTranslation();
  return (
    <Box
      padding={"50px 30px"}
      bgcolor="var(--app-empty-bg, #fedee5)"
      color="var(--app-empty-text, #000)"
      fontWeight="bold"
      borderRadius="8px"
    >
      <Box className="flex justify-center"><Empty /></Box>
      <Box className="no-record">{t("common.table.no_record")}</Box>
    </Box>
  );
};
